import { render, staticRenderFns } from "./VideoEdit.vue?vue&type=template&id=ae98237a&scoped=true&"
import script from "./VideoEdit.vue?vue&type=script&lang=js&"
export * from "./VideoEdit.vue?vue&type=script&lang=js&"
import style0 from "./VideoEdit.vue?vue&type=style&index=0&id=ae98237a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae98237a",
  null
  
)

export default component.exports